<app-leveltwo [pageName]="'Inter-Spousal Exclusion'">
    <div heading="General Info" class="General">
      <h3>{{'Inter-Spousal.SearchTitle'|translate}}</h3>

      <p [innerHTML]="'Inter-Spousal.Theinter'|translate"></p>

      <p [innerHTML]="'Inter-Spousal.Thereisno'|translate"></p>
      <p>{{'Inter-Spousal.FromJune'|translate}}</p>
      <p class="mb-0"><b>{{'Inter-Spousal.FilingReq'|translate}}</b></p>
      <p [innerHTML]="'Inter-Spousal.Whenrecording'|translate"></p>


    </div>

</app-leveltwo>
